import { TimeEntryCorrectionData } from '../../../../api/generated/data-contracts';
import { TimeEntryRow, CorrectionRow, TimeEntryCorrectionRow } from '../correctionsStore';

export const buildCorrectionsGridRows = (data: TimeEntryCorrectionData): TimeEntryCorrectionRow[] => {
    const rows: TimeEntryCorrectionRow[] = [];

    // Now that the backend provides the proper relationships, we can use them directly
    Object.values(data.timeEntries).forEach(timeEntry => {
        // Get the related data
        const project = data.projects[timeEntry.projectId];
        const task = data.tasks[timeEntry.taskId];
        const user = data.users[timeEntry.userId];

        // Create the time entry row
        const timeEntryRow: TimeEntryRow = {
            id: timeEntry.id,
            name: `${project?.name || 'Unknown Project'} / ${user?.name || 'Unknown User'} / ${task?.name || 'Unknown Task'} - ${new Date(
                timeEntry.date,
            ).toLocaleDateString()}`,
            type: 'timeEntry',
            timeEntry,
            projectId: timeEntry.projectId,
            taskId: timeEntry.taskId,
            userId: timeEntry.userId,
            projectName: project?.name || 'Unknown Project',
            taskName: task?.name || 'Unknown Task',
            userName: user?.name || 'Unknown User',
        };

        rows.push(timeEntryRow);

        // Add correction subrows if they exist
        if (timeEntry.corrections && timeEntry.corrections.length > 0) {
            timeEntry.corrections.forEach(correction => {
                const correctionRow: CorrectionRow = {
                    id: correction.id,
                    name: `Correction: ${correction.comment.substring(0, 50)}${correction.comment.length > 50 ? '...' : ''}`,
                    type: 'correction',
                    parentId: timeEntry.id,
                    correction,
                };
                rows.push(correctionRow);
            });
        }
    });

    return rows;
};
